export function initGoogleAnalitics() {
  // @ts-expect-error Property 'dataLayer' does not exist on type 'Window & typeof globalThis'.ts(2339)
  window.dataLayer = window.dataLayer || [];
  // @ts-expect-error Cannot find name 'dataLayer'.ts(2304)
  function gtag(...args){dataLayer.push(args);}
  gtag('js', new Date());
  gtag('config', 'G-S16ERLW93J');
};
